import { render, staticRenderFns } from "./DefaultSidebarMobile.vue?vue&type=template&id=05edff17"
import script from "./DefaultSidebarMobile.vue?vue&type=script&lang=ts"
export * from "./DefaultSidebarMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports